import { Backdrop, Button, CircularProgress, Container, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Context } from "../../App";

export default function UserCompteForm({onLogin}) {
    const { region, setIsConnected, setUserId } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);
    const [egliseLoad, setEgliseLoad] = React.useState(true);
    const [eglises, setEglises] = React.useState([]);

    const [genre, setGenre] = React.useState('Mr');
    const [nom, setNom] = React.useState('');
    const [prenom, setPrenom] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [tel, setTel] = React.useState('');
    const [voie, setVoie] = React.useState('');
    const [zip_code, setZipCode] = React.useState('');
    const [ville, setVille] = React.useState('');
    const [adresse_complement, setAdresseComplement] = React.useState('');
    const [eglise, setEglise] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const [passwordError, setPasswordError] = React.useState('');
    const [msg, setMsg] = React.useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        if(password.length < 8) {
            setPasswordError('Le mot de passe doit contenir au moins 8 caractères');
            return;
        } else if (password !== confirmPassword) {
            setPasswordError('Les mots de passe ne correspondent pas');
            return;
        } else {
            setPasswordError('');
            setLoading(true);

            fetch(`${process.env.REACT_APP_ESDRAS_API_URL}/auth/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa((localStorage.getItem('anonUserId') || '')+':'+password),
                },
                body: JSON.stringify({
                    mail,
                    genre,
                    nom,
                    prenom,
                    tel,
                    password,
                    voie,
                    zip_code,
                    ville,
                    adresse_complement,
                    region: !!region ? [region] : [],
                    eglise
                }),
            })
            .then(async response => {
                const token = response.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if (!response.ok) {
                    const json = await response.json();
                    setMsg(json.error || 'Erreur lors de l\'enregistrement');
                }else if (response.status === 201) {
                    const token = response.headers.get('x-auth-token');
                    if (token) localStorage.setItem('token', token);
                    const json = await response.json();
                    if(!!json && typeof json === 'object') {
                        localStorage.setItem('user', JSON.stringify(json._id));
                        localStorage.setItem('userData', JSON.stringify(json));
                        setUserId(json._id);
                        setIsConnected(true);
                    }
                    onLogin()
                }else setMsg('Erreur lors de l\'enregistrement');
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.error('Erreur lors de l\'inscription :', error);
                alert('Une erreur est survenue. Veuillez réessayer plus tard.');
            });
        }
    }

    useEffect(()=>{
        const query = new URLSearchParams({ region, type:'église' }).toString();
    
        fetch(process.env.REACT_APP_THYBA_API_URL.concat('/public/eglises/by?'+ query), {method: 'GET'})
        .then((res) => res.json())
        .then((data) => setEglises(data))
        .catch((err) => console.error("Error fetching eglises:", err))
        .finally(() => setEgliseLoad(false));
    }, [region])

    return <Container component='form' onSubmit={handleSubmit} maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, rowGap:2, minWidth: '400px' }}>
        <Typography variant="h4" align="center" sx={{ mb: !!msg ? 0 : 2 }}>Je m'inscris</Typography>

        {!!msg && <Typography variant="body2" color="error" align="center">{msg}</Typography>}

        <TextField fullWidth select label="Genre" variant="outlined" value={genre} required
        onChange={(e) => setGenre(e.target.value)} slotProps={{ select: {native: true}, inputLabel:{shrink: true} }} sx={{ mb: 2 }}>
            <option disabled value="">Sélectionnez un genre</option>
            <option value="Mr">Monsieur</option>
            <option value="Mme">Madame</option>
        </TextField>

        <TextField fullWidth label="Nom" variant="outlined" value={nom} required autoComplete="family-name"
        onChange={(e) => setNom(e.target.value)} />
        <TextField fullWidth label="Prénoms" variant="outlined" value={prenom} required autoComplete="given-name"
        onChange={(e) => setPrenom(e.target.value)} />

        <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required type="email" autoComplete="email"
        onChange={(e) => setMail(e.target.value)} />

        <TextField fullWidth type="phone" label="GSM" variant="outlined" value={tel} autoComplete="tel"
        onChange={(e) => setTel(e.target.value)} />

        {region && <TextField fullWidth label="Eglise" variant="outlined" value={eglise} 
        onChange={(e) => setEglise(e.target.value!=="" ? Number(e.target.value) : "")} select 
        slotProps={{ select: {native: true}, inputLabel:{shrink: true} }} sx={{ mb: 2 }}>
            <option value="">Sélectionnez une église (optionel)</option>
            {egliseLoad ? <option disabled>Chargement des églises...</option> :
            eglises.sort((a,b)=>a.nom>b.nom?1:-1).map((eglise) => (
                <option key={eglise._id} value={eglise.number}>{eglise.nom}</option>
            ))}
        </TextField>}

        <Typography variant="h6" sx={{ mt: 2 }}>Adresse</Typography>
        <TextField fullWidth label="Numéro et nom de la voie" variant="outlined" value={voie} autoComplete="address-line1"
        onChange={(e) => setVoie(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Complément d'adresse" variant="outlined" value={adresse_complement} autoComplete="address-line2"
        onChange={(e) => setAdresseComplement(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Code postal" variant="outlined" value={zip_code} required autoComplete="postal-code"
        onChange={(e) => setZipCode(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Ville" variant="outlined" value={ville} required autoComplete="address-level2"
        onChange={(e) => setVille(e.target.value)} sx={{ mb: 2 }} />

        <Typography variant="h6" sx={{ mt: 2 }}>Mot de passe</Typography>
        <TextField fullWidth type="password" label="Mot de passe" variant="outlined" required
        onChange={(e) => setPassword(e.target.value)} />
        <TextField fullWidth type="password" label="Confirmer le mot de passe" variant="outlined" required error={!!passwordError}
        helperText={passwordError} onChange={(e) => setConfirmPassword(e.target.value)} sx={{ mb: 4 }} />

        {!!msg && <Typography variant="body2" color="error" align="center">{msg}</Typography>}
        <Button variant="contained" type='submit' sx={{alignSelf: 'center', px: 5, mb: 2}}>Enregistrer</Button>

        <Backdrop open={loading}><CircularProgress/></Backdrop>

    </Container>
}